<account-menu [selectedMenu]="1" [me]="me"></account-menu>

<div class="col-lg-9 col-md-9 col-sm-8 content-panel-wrapper no-padding-mobile">
  <h2 class="page-title">Dashboard</h2>

  <div class="page-sub-title-alt">Welcome Back {{me.firstname}}</div>

  <div class="">

    <!-- Total Credits Issued Panel -->
    <div class="col-lg-8 col-md-10 col-sm-12 col-lg-offset-2 col-md-offset-1 col-sm-offset-0 no-padding-mobile">
      <div class="panel">
        <div class="panel-title">Available Credits</div>

        <div class="push-down-25">
          <div class="col-sm-12 col-xs-12 no-padding-mobile">
            <div class="panel-sec-title">
              {{model.availableCredits}}
            </div>
            <div class="panel-sec-content">Credits</div>
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div>

    <!-- Total Credits Issued Panel -->
    <div class="col-lg-8 col-md-10 col-sm-12 col-lg-offset-2 col-md-offset-1 col-sm-offset-0 no-padding-mobile">
      <div class="panel">
        <div class="panel-title">Total Issued Credits</div>

        <div class="push-down-25">
          <div class="col-sm-4 col-xs-4 no-padding-mobile">
            <div class="panel-sec-title">
              {{model.totalIssued25min}}
            </div>
            <div class="panel-sec-content">25 Min</div>
          </div>

          <div class="col-sm-4 col-xs-4 no-padding-mobile">
            <div class="panel-sec-title">
              {{model.totalIssued50min}}
            </div>
            <div class="panel-sec-content">50 Min</div>
          </div>

          <div class="col-sm-4 col-xs-4 no-padding-mobile">
            <div class="panel-sec-title">
              {{model.totalIssued80min}}
            </div>
            <div class="panel-sec-content">80 Min</div>
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div>

    <!-- Total Credits Used Panel -->
    <div class="col-md-8 col-sm-12 col-md-offset-2 col-sm-offset-0 no-padding-mobile">
      <div class="panel">
        <div class="panel-title">Total Used Credits</div>

        <div class="push-down-25">
          <div class="col-sm-4 col-xs-4 no-padding-mobile">
            <div class="panel-sec-title">
              {{model.totalUsed25min}}
            </div>
            <div class="panel-sec-content">25 Min</div>
          </div>

          <div class="col-sm-4 col-xs-4 no-padding-mobile">
            <div class="panel-sec-title">
              {{model.totalUsed50min}}
            </div>
            <div class="panel-sec-content">50 Min</div>
          </div>

          <div class="col-sm-4 col-xs-4 no-padding-mobile">
            <div class="panel-sec-title">
              {{model.totalUsed80min}}
            </div>
            <div class="panel-sec-content">80 Min</div>
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div>



    <div class="clear"></div>

    <!-- Supported Browsers Panel -->
    <div class="col-lg-12 col-md-12 col-sm-12 no-padding-mobile">
      <div class="panel-clear">
        <div class="panel-title"><strong>Supported Devices</strong></div>

        <div class="panel-sub-content-alt">
          You can use MindBerry on any of the following devices
        </div>

        <div class="push-down-20" style="display:flex; align-items:flex-end; flex-wrap:wrap;">
          <div class="col-sm-3 col-xs-6">
            <div><img src="/images/devices/laptop.png" /></div>
            <div>Laptop</div>
          </div>
          <div class="col-sm-3 col-xs-6">
            <div><img src="/images/devices/desktop.png" /></div>
            <div>Desktop</div>
          </div>
          <div class="col-sm-3 col-xs-6">
            <div><img src="/images/devices/tablet.png" /></div>
            <div>Tablet</div>
          </div>
          <div class="col-sm-3 col-xs-6">
            <div><img src="/images/devices/phone.png" style="width:75%;" /></div>
            <div>Mobile</div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </div>

  </div>
</div>
